import React from "react";
import { Conversation } from "./types";
import { lastMessagePreview } from "./helpers";
import { PinIcon, FlameIcon, MuteIcon, CheckIcon } from "./icons";
import { Avatar, vibeRingKind } from "../Avatar";

export function ConversationRow({ conv, isSelected, onClick, myUserId, lang }: { conv: Conversation; isSelected: boolean; onClick: () => void; myUserId?: string; lang: string }) {
  const avatarId = conv.other_user_id || conv.community_id || conv.ritual_id || conv.id;
  const preview = lastMessagePreview(conv, lang);
  // Le statut envoyé/lu façon Snapchat ne concerne QUE mon propre dernier message envoyé — même
  // calcul déjà utilisé dans la bulle ouverte (MessageBubble.tsx) : comparaison du timestamp du
  // message avec le curseur de lecture de l'autre participant, pas de nouvelle sémantique.
  const isMyLastMessage = !!conv.last_message_sender_id && conv.last_message_sender_id === myUserId;
  const lastMessageRead = isMyLastMessage && !!conv.other_last_read_at && !!conv.last_message_at
    && conv.last_message_at <= conv.other_last_read_at;
  return (
    <div onClick={onClick} style={{ display: "flex", alignItems: "center", gap: 12, padding: "12px 16px", borderBottom: "1px solid #F8F8F8", cursor: "pointer", backgroundColor: isSelected ? "#F0F0F0" : "transparent" }}>

      <Avatar
        id={avatarId}
        name={conv.name}
        uri={conv.avatar_url || conv.cover_url}
        size={42}
        online={conv.online}
        showOnline={conv.type === "direct"}
        ringKind={conv.type === "direct" ? vibeRingKind(conv.other_has_real, conv.other_has_active) : null}
      />

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 3 }}>
          <span style={{ fontSize: 14, fontWeight: conv.unread > 0 ? 700 : 500, color: "#0a0a0a", display: "flex", alignItems: "center", gap: 5 }}>
            {conv.pinned && <PinIcon size={12} color="#999" />}
            {conv.name || "—"}
            {conv.disappearing && <FlameIcon size={12} />}
            {conv.muted && <MuteIcon size={13} color="#bbb" />}
          </span>
          {conv.last_message_at && <span style={{ fontSize: 11, color: conv.unread > 0 ? "#0a0a0a" : "#999", flexShrink: 0 }}>{new Date(conv.last_message_at).toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" })}</span>}
        </div>

        {conv.type === "community" && <div style={{ fontSize: 11, color: "#999", marginBottom: 2 }}>{conv.members?.toLocaleString()} membres</div>}
        {conv.type === "ritual" && (
          <div style={{ display: "flex", alignItems: "center", gap: 6, marginBottom: 2 }}>
            <span style={{ fontSize: 11, color: "#999" }}>{conv.members} participants</span>
            <span style={{ backgroundColor: "#F0F0F0", borderRadius: 10, padding: "1px 6px", fontSize: 10, color: "#333333", fontWeight: 600 }}>{conv.streak} sem.</span>
          </div>
        )}

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <span style={{ fontSize: 13, color: conv.unread > 0 ? "#0a0a0a" : "#999", fontWeight: conv.unread > 0 ? 600 : 400, display: "flex", alignItems: "center", gap: 4, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: 200 }}>
            {isMyLastMessage && preview && <CheckIcon double read={lastMessageRead} />}
            {preview}
          </span>
          {conv.unread > 0 && !conv.muted && <span style={{ backgroundColor: "#0a0a0a", color: "white", borderRadius: 10, padding: "2px 7px", fontSize: 11, fontWeight: 700, flexShrink: 0 }}>{conv.unread}</span>}
        </div>
      </div>
    </div>
  );
}
